export default function DSA_Shortest_Path() {
  return <div>DSA_Shortest_Path Component</div>;
}
